import { render, staticRenderFns } from "./SfLoader.vue?vue&type=template&id=7741e57a&functional=true&"
import script from "./SfLoader.vue?vue&type=script&lang=js&"
export * from "./SfLoader.vue?vue&type=script&lang=js&"
import style0 from "./SfLoader.vue?vue&type=style&index=0&id=7741e57a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports